import React from 'react';
import { PageBody, PageHead } from '../../components/aa';
import { BillingPanel } from '../../components/settings/BillingPanel';

const BillingPage: React.FC = () => (
  <PageBody>
    <PageHead title="Billing" />
    <BillingPanel />
  </PageBody>
);

export default BillingPage;
